const new_books = [
  "Book Name",
  "Published by",
  "Role",
  "Book Upload",
  "Status",
  "Actions",
];

const final_approval_book = [
  "Book Name",
  "Published by",
  "Role",
  "Book Upload",
  "Reviewer",
  "Review Submitted",
  "Revision Sent",
  "Status",
  "Actions",
];

const revised_partners = [
  "Book Name",
  "Published by",
  "Role",
  "Book Upload",
  "Reviewer",
  "Reviewed",
  "Revision Sent",
  "Status",
  "Actions",
];

const internal_review = [
  "Book Name",
  "Published by",
  "Role",
  "Book Upload",
  "Reviewer",
  "Status",
  "Actions",
];

const external_review = [
  "Book Name",
  "Published by",
  "Role",
  "Book Upload",
  "Reviewer",
  "Reviewed",
  "Revision Sent",
  "Status",
  "Actions",
];

const headers_enums = {
  new_books: 0,
  final_approval_book: 1,
  revised_partners: 2,
  internal_review: 3,
  external_review: 4,
};

export {
  new_books,
  final_approval_book,
  revised_partners,
  internal_review,
  external_review,
  headers_enums,
};
